"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.keys = exports.FieldWeightC = exports.StrategyC = exports.FilterC = exports.IgnoreIfNullTypeC = exports.FilterTypeC = void 0;
const t = __importStar(require("io-ts"));
const master_data_1 = require("../master-data");
const date_from_date_or_iso_string_1 = require("../codecs/date-from-date-or-iso-string");
exports.FilterTypeC = t.partial({
    equalTo: t.union([t.string, t.number, t.boolean, t.array(t.string), t.array(t.number), date_from_date_or_iso_string_1.DateFromDateOrISOString]),
    includes: t.string,
    isInArray: t.union([t.array(t.string), t.array(t.number)]),
    isNotInArray: t.union([t.array(t.string), t.array(t.number)]),
    isNull: t.boolean,
    lessThan: t.union([t.number, date_from_date_or_iso_string_1.DateFromDateOrISOString]),
    lessThanOrEqualTo: t.union([t.number, date_from_date_or_iso_string_1.DateFromDateOrISOString]),
    moreThan: t.union([t.number, date_from_date_or_iso_string_1.DateFromDateOrISOString]),
    moreThanOrEqualTo: t.union([t.number, date_from_date_or_iso_string_1.DateFromDateOrISOString]),
    notEqualTo: t.union([t.string, t.number, t.boolean, t.array(t.string), t.array(t.number), date_from_date_or_iso_string_1.DateFromDateOrISOString]),
    includesOneOf: t.union([t.array(t.string), t.array(t.number)]),
});
const filterTypeEquals = true;
exports.IgnoreIfNullTypeC = t.partial({ ignoreIfNull: t.boolean });
const ignoreIfNullEquals = true;
exports.FilterC = t.intersection([exports.FilterTypeC, exports.IgnoreIfNullTypeC]);
const filterEquals = true;
exports.StrategyC = t.union([t.literal('static'), t.literal('proportional')]);
const strategyEquals = true;
exports.FieldWeightC = t.intersection([
    t.type({ weight: t.number, strategy: exports.StrategyC }),
    t.partial({ condition: exports.FilterC }),
]);
const fieldWeightEquals = true;
// @ts-ignore
exports.keys = t.union(master_data_1.masterDataKeys.map((key) => t.literal(key)));
//# sourceMappingURL=types.js.map